<template>
	<div class="admin-page beautify_scroll">
		<!-- 项目列表页布局 -->
		<div class="admin-page-header">
			<div class="logo">
				<img src="@/assets/images/logo@2x.png" alt="" />

				<!-- 面包屑区域 -->
				<div v-if="projectInfo" class="breadcrumbs">
					<div class="line"></div>
					<div class="breadcrumb-items">
						<div class="img-box">
							<img
								@click="backClick"
								src="@/assets/images/back.png"
								alt=""
							/>
						</div>
						<div class="breadcrumb">
							<!-- 项目详情 -->
							{{
								projectInfo.title
									? projectInfo.title
									: "项目详情"
							}}
							<div v-if="projectInfo.name" class="project-name">
								/ {{ projectInfo?.name }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="tools">
				<a-dropdown>
					<a class="ant-dropdown-link" @click.prevent>
						{{ userName }}
						<DownOutlined />
					</a>
					<template #overlay>
						<a-menu>
							<a-menu-item>
								<a href="javascript:;" @click="goUserCenter"
									>个人中心</a
								>
							</a-menu-item>
							<a-menu-item>
								<a href="javascript:;" @click="goStrategy"
									>电价策略模板</a
								>
							</a-menu-item>
							<a-menu-item>
								<a href="javascript:;" @click="exit"
									>退出登录</a
								>
							</a-menu-item>
						</a-menu>
					</template>
				</a-dropdown>
			</div>
		</div>
		<div class="admin-page-content">
			<router-view></router-view>
		</div>
		<div class="copyright" @click="goCompanyHome">
			<img src="@/assets/images/foot@2x.png" alt="" />
		</div>
	</div>
</template>

<script setup>
	import { onMounted, reactive, ref, watch } from "vue";
	import { DownOutlined } from "@ant-design/icons-vue";
	// 引入vuex
	import { useStore } from "vuex";
	const store = useStore();
	// 引入router
	import { useRouter } from "vue-router";
	import { message } from "ant-design-vue";
	const router = useRouter();
	import { goCompanyHome } from "../plugins/index.js";

	// 用户名称
	const userName = ref("");

	// 存储项目名称
	const projectInfo = ref(null);

	const goHome = () => {
		// router.push("/");
	};

	// 后退
	const backClick = () => {
		router.push("/project");
	};
	// 用户信息页
	const goUserCenter = () => {
		router.push("/user");
	};
	// 电价策略页
	const goStrategy = () => {
		router.push("/strategy");
	}
	// 退出
	const exit = () => {
		store.commit("upDateUserInfo", {});
		sessionStorage.removeItem("userInfo");
		message.success("退出成功！");
		setTimeout(() => {
			router.replace("/login");
		}, 200);
	};

	// 监听store中的breadcrumb信息
	watch(
		() => store.state.breadcrumbInfo,
		newVal => {
			projectInfo.value = newVal;
		},
		{
			immediate: true,
			deep: true
		}
	);

	watch(
		() => store.state.userInfo,
		newVal => {
			if (store.state.userInfo) {
				userName.value = store.state.userInfo.nickname;
			}
		},
		{ immediate: true, deep: true }
	);

	onMounted(() => {
		if (store.state.userInfo) {
			userName.value = store.state.userInfo.nickname;
		}
	});
</script>

<style lang="less" scoped>
	.admin-page {
		width: 100%;
		height: 100vh;
		min-width: 1280px;
		overflow-x: auto;
		background-image: url(../assets/images/bg2.png);
		background-size: 100% 100%;
		background-attachment: fixed;
		position: relative;
		box-sizing: border-box;
		// position: relative;

		&-header {
			width: 100%;
			height: 56px;
			background: #ffffff;
			border: 1px solid #dbe0e8;
			position: fixed;
			top: 0;
			z-index: 999;

			.logo {
				position: absolute;
				left: 32px;
				bottom: 8px;

				display: flex;
				align-items: center;
				img {
					width: 148px;
					height: 40px;
				}

				.breadcrumbs {
					display: flex;
					align-items: center;

					img {
						width: 24px;
						height: 24px;
						opacity: 0.85;
						cursor: pointer;
					}
					.img-box {
						:hover {
							background: #a2abbb29;
							border-radius: 4.67px;
							padding: 2px;
						}
					}

					.line {
						width: 1px;
						height: 36px;
						opacity: 0.5;
						border: 1px solid #a2abbb;
						margin: 0px 24px;
					}

					.breadcrumb-items {
						display: flex;
						align-items: center;

						.breadcrumb {
							height: 26px;
							opacity: 0.85;
							font-family: PingFangSC-Medium;
							font-weight: 600;
							font-size: 16px;
							color: #000000;
							letter-spacing: 0;
							line-height: 26px;
							margin-left: 8px;

							display: flex;
							align-items: center;

							.project-name {
								opacity: 0.65;
								font-family: PingFangSC-Medium;
								font-weight: 500;
								font-size: 14px;
								color: #000000;
								letter-spacing: 0;
								margin-left: 8px;
							}
						}
					}
				}
			}

			.tools {
				position: absolute;
				right: 24px;
				top: 50%;
				font-size: 16px;
				transform: translateY(-50%);

				font-family: PingFangSC-Medium;
				font-size: 14px;
				color: #000000;
				letter-spacing: 0;
				text-align: right;
			}
		}

		&-content {
			margin-top: 56px;
			padding: 0px 32px 0px 32px;
			min-height: calc(100vh - 110px);
			background-image: linear-gradient(
				270deg,
				#e9eff6 0%,
				#e9eff6 82%,
				#e9eff600 100%
			);
		}

		.copyright {
			text-align: center;
			z-index: 9999;
			margin: 12px 0px;
			cursor: pointer;
			img {
				width: 385px;
				height: 24px;
			}
		}
	}
</style>
